import React, { useContext } from "react";
import ExpandableText from "./ExpandableText";
import { icons } from "../../../constants";
import { useTheme } from "../../../utils/ThemeContext";
import { TranslationsContext } from "../../../utils/TranslationsContext";
import IconWithTooltip from "../../IconWithTooltip/IconWithTooltip";

const ChildrenRow = ({
  rowData,
  totalWidth,
  isLoadingData,
  isPlaceholder,
  query,
  onClick,
  seeAllColumns,
  onNameClick,
}) => {
  const { theme } = useTheme();
  const { t } = useContext(TranslationsContext);
  if (!rowData) return null;

  return (
    <div
      className={`flex-direction-row items-center relative table-children-row`}
    >
      {Object.entries(rowData).map(([key, val]) => {
        let columnWidth = (rowData.width[key.toLowerCase()] / totalWidth) * 100;
        if (
          key === "width" ||
          key === "id" ||
          key === "className" ||
          key === "RowClassName" ||
          key === "missingTemplate" ||
          key?.toLowerCase() === "children"
        )
          return null;

        return (
          <div
            className={`relative flex-direction-row items-center table-cell ${
              rowData.className
            } ${key} ${seeAllColumns ? "" : "hide"}`}
            key={key}
            style={{ width: `${columnWidth}%` }}
          >
            {key === "actions_3" ? (
              <div className="flex-direction-row gap-4 items-center">
                <IconWithTooltip tooltip={t("EDIT")}>
                  <img
                    className="pointer"
                    alt="edit"
                    src={theme === "light" ? icons.pen : icons.pen_dark}
                    width={26}
                    height={26}
                    onClick={(e) => {
                      e.stopPropagation();
                      onClick(rowData.id);
                    }}
                  />
                </IconWithTooltip>
              </div>
            ) : key === "naziv" ? (
              <ExpandableText
                text={String(val)}
                isLoadingData={isLoadingData}
                isPlaceholder={isPlaceholder}
                className={rowData.className + " " + key}
                query={query}
                status={key === "status"}
                onClick={(e) => {
                  e.stopPropagation();
                  onNameClick(rowData.id);
                }}
              />
            ) : (
              <ExpandableText
                text={String(val)}
                isLoadingData={isLoadingData}
                isPlaceholder={isPlaceholder}
                className={rowData.className + " " + key}
                query={query}
                status={key === "status"}
              />
            )}
            {key === "naziv" && rowData.missingTemplate && (
              <IconWithTooltip tooltip={t("GROUP_MISSING_DESIGN_TEMPLATE")}>
                <img
                  alt="warning"
                  src={icons.warning}
                  width={26}
                  height={26}
                />
              </IconWithTooltip>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ChildrenRow;
